import axios from "axios";
import { env } from "../config/env";
import { getAuthToken } from "../pages/AdminAuth/components/authStore";

const BASE_URL =
  env?.CATALOG_BASE_URL || process.env.REACT_APP_CATALOG_BASE_URL || "";

function authHeaders() {
  const token = getAuthToken?.() || "";
  return {
    accept: "application/json",
    Authorization: token ? `Bearer ${token}` : "",
  };
}

function isFormData(value) {
  return typeof FormData !== "undefined" && value instanceof FormData;
}

export const CatalogService = {
  getCategories: (params = {}) =>
    axios.get(`${BASE_URL}/api/admin/categories/`, {
      headers: authHeaders(),
      params,
    }),

  createCategory: (data) =>
    axios.post(`${BASE_URL}/api/admin/categories/`, data, {
      headers: isFormData(data)
        ? {
          ...authHeaders(),
        }
        : {
          ...authHeaders(),
          "Content-Type": "application/json",
        },
    }),

  updateCategory: (id, data) =>
    axios.put(`${BASE_URL}/api/admin/categories/${id}`, data, {
      headers: isFormData(data)
        ? {
          ...authHeaders(),
        }
        : {
          ...authHeaders(),
          "Content-Type": "application/json",
        },
    }),

  deleteCategory: (id) =>
    axios.delete(`${BASE_URL}/api/admin/categories/${id}`, {
      headers: authHeaders(),
    }),

  reorderCategories: (payload) => {
    const body = Array.isArray(payload) ? { items: payload } : payload;

    return axios.patch(
      `${BASE_URL}/api/admin/categories/reorder`,
      body,
      {
        headers: {
          ...authHeaders(),
          "Content-Type": "application/json",
        },
      }
    );
  },

  getBrands: () =>
    axios.get(`${BASE_URL}/api/admin/brands/`, {
      headers: authHeaders(),
    }),

  createBrand: (data) =>
    axios.post(`${BASE_URL}/api/admin/brands/`, data, {
      headers: isFormData(data)
        ? {
          ...authHeaders(),
        }
        : {
          ...authHeaders(),
          "Content-Type": "application/json",
        },
    }),

  updateBrand: (id, data) =>
    axios.put(`${BASE_URL}/api/admin/brands/${id}`, data, {
      headers: isFormData(data)
        ? {
          ...authHeaders(),
        }
        : {
          ...authHeaders(),
          "Content-Type": "application/json",
        },
    }),

  deleteBrand: (id) =>
    axios.delete(`${BASE_URL}/api/admin/brands/${id}`, {
      headers: authHeaders(),
    }),

  getUnits: () =>
    axios.get(`${BASE_URL}/api/admin/units/`, {
      headers: authHeaders(),
    }),

  createUnit: (data) =>
    axios.post(`${BASE_URL}/api/admin/units/`, data, {
      headers: {
        ...authHeaders(),
        "Content-Type": "application/json",
      },
    }),

  updateUnit: (id, data) =>
    axios.put(`${BASE_URL}/api/admin/units/${id}`, data, {
      headers: {
        ...authHeaders(),
        "Content-Type": "application/json",
      },
    }),

  deleteUnit: (id) =>
    axios.delete(`${BASE_URL}/api/admin/units/${id}`, {
      headers: authHeaders(),
    }),
};
